import styled from 'styled-components';
import { AiColor16 } from 'ui/icons/aurora/16px/AiColor16';
import { caption, colors, spacing } from 'ui/theme';

const StyledBadge = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.quarter};
  ${caption};
  color: ${colors.textSecondary};
`;

export const NBABadge = () => {
  return (
    <StyledBadge>
      <AiColor16 />
      <span>Next Best Action</span>
    </StyledBadge>
  );
};
